import * as React from 'react';

function Fencing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.457 12.556l.963 1.012-1.494 1.56c.694 1.207.475 2.858-.605 4.045l-.134.14-.145.138-.15.13-1.817-1.818a9.947 9.947 0 01-1.262 1.55 10.008 10.008 0 01-1.939 1.507l-.312.18L3 20.438c.687-1.062 1.25-1.813 1.687-2.25.305-.305.76-.668 1.366-1.094l.208-.144-1.842-1.841c.084-.102.174-.201.268-.296 1.148-1.148 2.797-1.439 4.038-.818l.147.08 1.585-1.52zM3.562 3l11.565 11.074c1.256-.721 2.992-.456 4.186.739.095.095.184.194.268.295l-1.842 1.842c.711.487 1.236.9 1.574 1.238.437.437 1 1.188 1.687 2.25l-.562.562a10.09 10.09 0 01-2.25-1.686 9.918 9.918 0 01-1.263-1.55l-1.817 1.817a4.062 4.062 0 01-.296-.268c-1.193-1.194-1.46-2.93-.738-4.185L3 3.562 3.562 3zm16.876 0l.562.562-7.48 7.812-.917-.872L20.438 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Fencing;
